import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AllArticles from './pages/AllArticles';
import ContactPage from './pages/ContactPage';
import AgeVerificationModal from './components/AgeVerificationModal'; // Import the Age Verification Modal
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import netlifyIdentity from 'netlify-identity-widget';

function App() {
  const AGE_VERIFICATION_EXPIRATION_DAYS = 30;

  const [isAgeVerified, setIsAgeVerified] = useState(false);
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    netlifyIdentity.init();
    const botPattern = /bot|googlebot|crawler|spider|robot|crawling/i;
    const userAgent = navigator.userAgent;

    if (botPattern.test(userAgent)) {
      setIsBot(true);
      setIsAgeVerified(true);
      return;
    }

    const ageVerified = localStorage.getItem('isAgeVerified');
    const verificationDate = localStorage.getItem('verificationDate');

    if (ageVerified === 'true' && verificationDate) {
      const now = new Date();
      const storedDate = new Date(verificationDate);

      const differenceInDays = (now - storedDate) / (1000 * 60 * 60 * 24);

      if (differenceInDays <= AGE_VERIFICATION_EXPIRATION_DAYS) {
        setIsAgeVerified(true);
      } else {
        localStorage.removeItem('isAgeVerified');
        localStorage.removeItem('verificationDate');
      }
    }
  }, []);

  const handleAgeVerification = () => {
    const now = new Date();
    localStorage.setItem('isAgeVerified', 'true');
    localStorage.setItem('verificationDate', now.toISOString());
    setIsAgeVerified(true);
  };

  if (!isAgeVerified && !isBot) {
    return <AgeVerificationModal onConfirm={handleAgeVerification} />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/all-articles" element={<AllArticles />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
